var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 28.128,
    viewBox: "0 0 36 28.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exchange-alt",
    "data-name": "Icon awesome-exchange-alt",
    d: "M0,11.813V10.688A1.687,1.687,0,0,1,1.688,9H27V5.625a1.689,1.689,0,0,1,2.881-1.193l5.625,5.625a1.688,1.688,0,0,1,0,2.386l-5.625,5.625A1.689,1.689,0,0,1,27,16.875V13.5H1.688A1.687,1.687,0,0,1,0,11.813ZM34.313,22.5H9V19.125a1.689,1.689,0,0,0-2.881-1.193L.494,23.557a1.688,1.688,0,0,0,0,2.386l5.625,5.625A1.689,1.689,0,0,0,9,30.375V27H34.313A1.687,1.687,0,0,0,36,25.313V24.188A1.687,1.687,0,0,0,34.313,22.5Z",
    transform: "translate(0 -3.936)",
    fill: "#527991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrows);
export default __webpack_public_path__ + "static/media/doubleArrows.9c1435ff.svg";
export { ForwardRef as ReactComponent };